import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { RequestTypeSetting } from '@/types/requests';

/**
 * Returns a function that resolves the localized label for an application's
 * request type setting from `applications:requestTypeSettings.<slug>.<name>`.
 * Falls back to the backend-provided `displayName` for settings without a
 * translation yet. Dots in the slug (e.g. `zoom.us`) become underscores
 * because i18next treats `.` as a key separator.
 */
export const useSettingDisplayName = () => {
  const { t } = useTranslation('applications');

  return useCallback(
    (
      applicationKey: string,
      setting: Pick<RequestTypeSetting, 'name' | 'displayName'>
    ) =>
      t(
        `requestTypeSettings.${applicationKey.replace(/\./g, '_')}.${setting.name}`,
        { defaultValue: setting.displayName }
      ),
    [t]
  );
};
